"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import * as React from "react";

import { SVGIcon } from "../SVGIcon";

/**
 * @deprecated use Filter from foundation/Filter
 * @trackcomponent
 */
export const Filter = React.memo(
  ({
    ref,
    className,
    ...props
  }: SVGIcon.IProps & React.RefAttributes<SVGElement>) => (
    <SVGIcon
      viewBox="0 0 12 12"
      fill="none"
      ref={ref}
      className={legacyIconCls(className)}
      {...props}
    >
      <path
        d="M9.30001 9.66659H12V10.3333H9.30001C9.14559 11.094 8.47299 11.6666 7.66667 11.6666C6.74619 11.6666 6 10.9204 6 9.99992C6 9.07944 6.74619 8.33325 7.66667 8.33325C8.47299 8.33325 9.14559 8.90584 9.30001 9.66659ZM5.30001 5.66659H12V6.33325H5.30001C5.14559 7.094 4.47299 7.66659 3.66667 7.66659C2.74619 7.66659 2 6.92039 2 5.99992C2 5.07944 2.74619 4.33325 3.66667 4.33325C4.47299 4.33325 5.14559 4.90584 5.30001 5.66659ZM10.6333 1.66659H12V2.33325H10.6333C10.4789 3.094 9.80632 3.66659 9 3.66659C8.07953 3.66659 7.33333 2.92039 7.33333 1.99992C7.33333 1.07944 8.07953 0.333252 9 0.333252C9.80632 0.333252 10.4789 0.905839 10.6333 1.66659ZM0 2.33325V1.66659H7.33333V2.33325H0ZM9 2.99992C9.55229 2.99992 10 2.5522 10 1.99992C10 1.44763 9.55229 0.999919 9 0.999919C8.44772 0.999919 8 1.44763 8 1.99992C8 2.5522 8.44772 2.99992 9 2.99992ZM0 6.33325V5.66659H2V6.33325H0ZM3.66667 6.99992C4.21895 6.99992 4.66667 6.5522 4.66667 5.99992C4.66667 5.44763 4.21895 4.99992 3.66667 4.99992C3.11438 4.99992 2.66667 5.44763 2.66667 5.99992C2.66667 6.5522 3.11438 6.99992 3.66667 6.99992ZM0 10.3333V9.66659H6V10.3333H0ZM7.66667 10.9999C8.21895 10.9999 8.66667 10.5522 8.66667 9.99992C8.66667 9.44763 8.21895 8.99992 7.66667 8.99992C7.11438 8.99992 6.66667 9.44763 6.66667 9.99992C6.66667 10.5522 7.11438 10.9999 7.66667 10.9999Z"
        fill="currentColor"
      />
    </SVGIcon>
  )
);
